// extracted by mini-css-extract-plugin
export default {"scrollableContainer":"Videos_scrollableContainer__ta1Uz","block":"Videos_block__wjoHP","loaderContainer":"Videos_loaderContainer__rq9So"};